import React, { useRef, useState, useEffect } from "react";
import "./Certificates.css";
import BackButton from "../../GoBack/GoBack";
import Certificate from "./TemplatesBasic/Certificates";
import Skeleton from "react-loading-skeleton";
import { StudentMapMenu } from "../../Map/MapMenu/MapMenu";
import { useGetStudentCertificates } from "../../../../../hooks/student/certificate/useGetStudentCertificate";
import { useParams } from "react-router-dom";

export const SchoolStudentQuestCertificate = () => {
  const certificateRefs = useRef({});
  const certificateRefsPreview = useRef([]);
  const [loading, setLoading] = useState(true);
  const { questId } = useParams();
  const { certificates, getStudentCertificates } = useGetStudentCertificates();
  const tenantUser = localStorage.getItem("tenant-user");

  console.log(JSON.parse(tenantUser)?.name)

  useEffect(() => {
    const fetchCertificates = async () => {
      const tenantUserRaw = localStorage.getItem("tenant-user");
      const studentId = tenantUserRaw
        ? Number(JSON.parse(tenantUserRaw)?.id)
        : null;

      if (!studentId || !questId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        await getStudentCertificates({
          studentId,
          questId,
        });
      } catch (error) {
        console.error("Failed to fetch certificates", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCertificates();
  }, [questId]);

  const handleDownload = (questName, logo, item) => {
    const certRef = certificateRefs.current[item.id];
    if (certRef) {
      certRef.generateCertificate(questName, logo, item);
    }
  };

  const [previewImage, setPreviewImage] = useState(null);
  console.log(previewImage);

  useEffect(() => {
    const certRef = certificateRefsPreview.current[8];
    if (certRef?.generateCertificate) {
      certRef
        .generateCertificate("Your Quest Name", true)
        .then((img) => setPreviewImage(img));
      // .catch(console.error);
    }
  }, []);

  return (
    <div className="StudentAdminBody StudentBodyMrgn">
      <div className="container-fluid">
        <div className="teacher-bodycontent mb-4">
          <section>
            <div className="row mb-4">
              <div className="col-md-12">
                <BackButton />
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-1"></div>
              {/* <div style={{ display: "none" }}>
                <CertificateImage
                  ref={async (el) => {
                    if (el) {
                      certificateRefsPreview.current[0] = el;
                      if (typeof el.generateCertificate === "function") {
                        const img = await el.generateCertificate(
                          "Your Quest Name",
                          true
                        );
                        setPreviewImage(img);
                        console.log("Generated image:", img); // confirm it's working
                      }
                    }
                  }}
                  studentName={student?.student?.name}
                  certificateFile={BhagatBanner}
                />
              </div> */}

              <div className="col-md-10 row justify-content-center">
                <div className="position-relative text-center">
                  {/* Desktop Image */}
                  <img
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/BlueBanner.png"
                    alt="quest"
                    className="img-fluid w-100 d-none d-md-block"
                    style={{ objectFit: "cover", height: "auto" }}
                  />

                  {/* Mobile Image */}
                  <img
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/BlueBannerMobile.png"
                    alt="quest"
                    className="img-fluid w-100 d-block d-md-none"
                    style={{ objectFit: "cover", height: "auto" }}
                  />

                  {/* Centered Text */}
                  <div
                    className="position-absolute top-50 start-50 translate-middle text-white text-center"
                    style={{
                      width: "100%",
                      padding: "0 1rem",
                      maxWidth: "100%",
                    }}
                  >
                    <h6 className="fw-semibold display-6 m-0">Certificates</h6>
                    <p className="fs-5 m-0">Your Journey Through Learning</p>
                  </div>
                </div>

                {loading ? (
                  <div className="d-flex flex-column align-items-center justify-content-center w-100 mt-5">
                    {/* Centered Text and Spinner */}
                    <div className="text-center mb-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                        style={{ width: "3rem", height: "3rem" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-3 fs-5 fw-semibold text-secondary">
                        Certificates are generating. Please wait...
                      </p>
                    </div>

                    {/* Skeleton Loader Cards */}
                    <div className="row w-100 justify-content-center">
                      {Array.from({ length: 8 }).map((_, index) => (
                        <div
                          key={index}
                          className="col-lg-3 col-md-4 col-sm-6 col-12 text-center mb-4"
                        >
                          <div className="skeleton-card p-3">
                            <Skeleton width="100%" height={150} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="row mt-5">
                    {certificates?.length === 0 ? (
                      <div>No Certificate found </div>
                    ) : (
                      certificates?.map((item, index) => (
                        <div
                          key={index}
                          className="col-lg-3 col-md-4 col-sm-6 col-12 text-center mb-4"
                        >
                          <div className="position-relative d-inline-block text-center">
                            <div className="quest-card border rounded-full shadow-lg pt-3 px-3 pb-0 position-relative text-center">
                              <div className="position-relative">
                                <img
                                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/certificate/certificate.png"
                                  alt="Certificate Preview"
                                  className="img-fluid rounded shadow-sm w-100"
                                  style={{
                                    maxHeight: "200px",
                                    objectFit: "cover",
                                  }}
                                />

                                {item?.is_unlocked && (
                                  <>
                                    <div
                                      className="position-absolute bottom-0 end-0 responsive-icon-container"
                                      onClick={() =>
                                        handleDownload(
                                          item?.title,
                                          item?.certificateFile,
                                          item
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img
                                        src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/certificate/DownloadIcon.png"
                                        alt="download"
                                        className="img-fluid download-icon"
                                      />
                                    </div>
                                    <Certificate
                                      ref={(el) => {
                                        if (el)
                                          certificateRefs.current[item?.id] =
                                            el;
                                      }}
                                      studentName={JSON.parse(tenantUser)?.name}
                                      certificateFile={item?.certificateFile}
                                      questName={item?.title}
                                    />
                                  </>
                                )}

                                {!item?.is_unlocked && (
                                  <div
                                    className="position-absolute top-0 start-0 w-100 h-100"
                                    style={{
                                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                                      pointerEvents: "none",
                                    }}
                                  ></div>
                                )}
                              </div>

                              {!item?.is_unlocked && (
                                <div className="position-absolute top-50 start-50 translate-middle">
                                  <img
                                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/award/LockIcon.png"
                                    alt="lock"
                                    className="img-fluid"
                                    width={40}
                                  />
                                </div>
                              )}

                              <div className="justify-content-center text-center">
                                <p className="fw-bold mt-1">{item?.title}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
              <div className="col-md-1"></div>
            </div>
            <StudentMapMenu />
          </section>
          <div style={{ position: "absolute" }}>
            {/* Left Image */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/LeftSideDesign.png"
              alt="left"
              className="position-fixed"
              style={{
                left: 0,
                top: "10vh",
                height: "90vh",
                bottom: "auto",
                width: "auto",
                zIndex: -1, // Keeps it in the background
              }}
            />

            {/* Right Image */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/common/RightSideDesign.png"
              alt="right"
              className="position-fixed"
              style={{
                right: 0,
                top: "20vh",
                height: "70vh",
                width: "auto",
                zIndex: -1, // Keeps it in the background
              }}
            />

            {/* Page Content */}
          </div>
        </div>
      </div>
    </div>
  );
};
